import React from "react";
import { makeStyles } from "tss-react/mui";
import TextField from "@mui/material/TextField";

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "20px",
  },
  input: {
    padding: '12px 15px',
  },
  button: {
    marginTop: "20px",
  },
}));

export default function CustomTextField(props) {
  const { classes } = useStyles();

  return (
    <TextField
      label={props.label}
      className={props.className}
      value={props.value}
      onChange={props.onChange}
      error={props.error}
      helperText={props.helperText}
      variant={props.variant || "outlined"}
      fullWidth={props.fullWidth}
      name={props.name}
      id={props.id}
      size={props.size}
      margin={props.margin}
      type={props.type}
      sx={props.sx}
      style={props.style}
      disabled={props.disabled}
      placeholder={props.placeholder}
      InputProps={{
        ...props.InputProps,
        classes: {
          input: classes.input, // Apply custom styles to the input element
        },
      }}
      InputLabelProps={props.InputLabelProps}
      multiline={props.multiline}
      rows={props.rows}
    />
  );
}
